var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotoAlternate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4710_33545",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4710_33545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.77775 35C7.01386 35 6.35993 34.728 5.81596 34.184C5.27199 33.6401 5 32.9861 5 32.2222V7.77775C5 7.01386 5.27199 6.35993 5.81596 5.81596C6.35993 5.27199 7.01386 5 7.77775 5H24.1389V7.77775H7.77775V32.2222H32.2222V15.8889H35V32.2222C35 32.9861 34.728 33.6401 34.184 34.184C33.6401 34.728 32.9861 35 32.2222 35H7.77775ZM28.8889 14.5V11.1389H25.5278V8.36112H28.8889V5H31.6667V8.36112H35.0278V11.1389H31.6667V14.5H28.8889ZM10 28.2778H30L23.9167 20.1667L18.7222 27.0278L14.8611 21.9167L10 28.2778Z",
    fill: "#7D7D7D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoAlternate);
export default __webpack_public_path__ + "static/media/photoAlternate.e87091a37f5832e52d169aaf7db56aa5.svg";
export { ForwardRef as ReactComponent };